export { startSegmentCollection, setSegmentBytesLimit } from './segmentCollection'
export { SEGMENT_BYTES_LIMIT } from './segmentCollection'
export type { BrowserSegmentMetadataAndSegmentSizes } from './buildReplayPayload'
